module.exports = __webpack_public_path__ + "media/audio26.bb6456fc.mp3";